<template>
  <div class="uk-animation-fade" v-html="content"></div>
</template>

<script>
import { resolveContent } from "../../utils/content";

export default {
  name: "content-section",
  props: ["content-key", "law", "brand"],
  computed: {
    formattedContentKey() {
      var contentKey = this.contentKey;
      if (this.law == 'ocpa' && this.contentKey.includes('submission-disclaimer')) {
        contentKey = 'submission-disclaimer';
      }

      return contentKey
    }
  },
  asyncComputed: {
    content: function() {
      return resolveContent(this.formattedContentKey).then(body => {
        if (this.contentKey == 'email-consent-disclaimer') {
          body = body.replace('{{ law }}', this.law.toUpperCase());
        }

        if (this.contentKey == 'error-out-of-state') {
          body = body.replace('{{ stateName }}', this.law == 'ccpa' ? 'a California' : 'an Oregon');
        } 

        if (this.contentKey == `error-cannot-identify`) {
          const lowerBrand = this.brand.toLowerCase()
          body = body.replace('{{ email }}', lowerBrand == 'netcredit' ? 'support@netcredit.com' : 'support@cashnetusa.com');
          body = body.replace('{{ number }}', lowerBrand == 'netcredit' ? '1-877-392-2014': '1-888-801-9075');
        }

        const stateNameContentKeys = ['select-data-request', 'access-data', 'delete-data'];
        if (stateNameContentKeys.includes(this.contentKey)) {
          body = body.replace('{{ stateName }}', this.law == 'ccpa' ? 'California' : 'Oregon');
        }

        return body;
      });
    }
  }
};
</script>

<style scoped>
</style>